import React, { useEffect, useState } from "react";
import "../../styles/Users.css";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import Header from "../../components/Header/Header.js";
import Revenue from "../../assets/Images/revenue.svg";
import { DownOutlined } from "@ant-design/icons";
import axios from "axios";
import SearchIcon from "@mui/icons-material/Search";
import { GetWebAccessToken } from "../../components/ReusebleComponents/ResuseableApiCalls";
import Cookie from "js-cookie";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import "../../CommonStyle/Tablestyling.css";
import CopyIcon from "../../assets/Images/copy.png";
import StatusFilter from "../../Common/Filters/StatusFilter/statusfilter.jsx";
import DateFilter from "../../Common/Filters/DateFilter/datefilter.jsx";

const ProPartnerUsers = () => {
  const [selectedTab, setSelectedTab] = useState("All");
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const [currentPage, setCurrentPage] = useState(1);
  const [expandedRow, setExpandedRow] = useState(null);
  const [dateFilter, setDateFilter] = useState({
    filterType: "Today",
    fromDate: "",
    toDate: "",
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [activeFilter, setActiveFilter] = useState(null);
  const [proPartnerRelatedData, setProPartnerRelatedData] = useState({
    revenueDetails: {},
    transactionData: [],
  });
  const paymentData = [
    {
      name: "Available Balance",
      value: proPartnerRelatedData?.revenueDetails?.revenue || 0,
      color: "#F26727",
    },
    {
      name: "Distributors Count",
      value: proPartnerRelatedData?.revenueDetails?.distributorsCount || 0,
      color: "#3C67B1",
    },
    {
      name: "Withdraw Amount",
      value: proPartnerRelatedData?.revenueDetails?.withdrawAmount || 0,
      color: "red",
    },
  ];
  const recordsPerPageOptions = [15, 25, 50, 100];
  const visiblePageCount = 3;

  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  function formatName(name) {
    return name
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  const handleGetReferralUserTransactionDetails = async () => {
    const baseUrl = process.env.REACT_APP_BACKEND_URL;
    const mobileNumber = Cookie.get("mobileNumber");
    const MerchantId = Cookie.get("MerchantId");
    const token = await GetWebAccessToken();
    try {
      const res = await axios.get(
        `${baseUrl}/refer/proPartner/RetailerTransactions/ByDistributor?MerchantId=${MerchantId}&mobileNumber=${mobileNumber}&fromDate=${dateFilter?.fromDate}&toDate=${dateFilter?.toDate}&filterType=${dateFilter?.filterType}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Cache-Control": "no-cache",
    "Pragma": "no-cache",
            "Content-Type": "application/json",
          },
        }
      );

      if (res?.status === 200 && res?.data && res?.data?.data?.length > 0) {
        console.log("responseData in pro partner users", res?.data);
        setProPartnerRelatedData({
          revenueDetails: res?.data?.revenueDetails,
          transactionData: res?.data?.data,
        });
      } else {
        console.log("No data found or request failed");
      }
    } catch (error) {
      console.log("Error to get ReferralUserTransactionDetails ===>", error);
    }
  };

  useEffect(() => {
    handleGetReferralUserTransactionDetails();
  }, [dateFilter]);

  const copyToClipboard = (merchantId) => {
    navigator.clipboard.writeText(merchantId);
  };

  const matchesSearchQuery = (fieldValue) => {
    const formattedQuery = searchQuery?.toString()?.toLowerCase();
    return fieldValue?.toLowerCase()?.includes(formattedQuery);
  };

  const filterBySearchQuery = (user) => {
    const matchesUsername = matchesSearchQuery(user?.userName);
    const matchesMerchantId = matchesSearchQuery(user?.merchantId);
    return matchesUsername || matchesMerchantId;
  };

  const handleFilterDataBasedOnActiveTab = () => {
    switch (selectedTab) {
      case "All":
        return proPartnerRelatedData?.transactionData.filter((user) =>
          filterBySearchQuery(user)
        );

      case "KYC Completed":
        return proPartnerRelatedData?.transactionData.filter((user) => {
          const kycStatus = user?.kycStatus === "Completed";
          return kycStatus && filterBySearchQuery(user);
        });

      case "KYC Pending":
        return proPartnerRelatedData?.transactionData.filter((user) => {
          const kycStatus = user?.kycStatus === "Pending";
          return kycStatus && filterBySearchQuery(user);
        });

      case "Active":
        return proPartnerRelatedData?.transactionData.filter((user) => {
          const status = user?.status === "Active";
          return status && filterBySearchQuery(user);
        });

      case "Deactive":
        return proPartnerRelatedData?.transactionData.filter((user) => {
          const status = user.status === "Deactive";
          return status && filterBySearchQuery(user);
        });

      default:
        return [];
    }
  };

  const tabs = ["All", "KYC Completed", "KYC Pending"];

  const filteredRows = handleFilterDataBasedOnActiveTab();
  const totalPages = Math.ceil(filteredRows.length / itemsPerPage);

  const startPage = Math.max(
    1,
    Math.min(
      currentPage - Math.floor(visiblePageCount / 2),
      totalPages - visiblePageCount + 1
    )
  );
  const endPage = Math.min(startPage + visiblePageCount - 1, totalPages);

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const formatNumber = (num) => {
    console.log("num", num)
    if(!num || num == undefined) return 0;
    if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(2) + "M";
    } else if (num >= 1_000) {
      return (num / 1_000).toFixed(2) + "k";
    }
    return num?.toFixed(2);
  };

  const paginateData = (data) => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return data.slice(startIndex, startIndex + itemsPerPage);
  };

  const handleFilterChangePaymentsType = (filters) => {
    setSelectedTab(filters);
  };
  const handleDateFilterChange = (filters) => {
    setDateFilter((prev) => ({
      ...prev,
      filterType: filters?.selectedDate,
      fromDate: filters?.customStartDate || "",
      toDate: filters?.customEndDate || "",
    }));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handlePrevNext = (newPage) => {
    setCurrentPage(newPage);
    const updatedStartPage = Math.max(
      1,
      Math.min(
        newPage - Math.floor(visiblePageCount / 2),
        totalPages - visiblePageCount + 1
      )
    );
    setCurrentPage(newPage);
  };

  return (
    <div>
      <div className="users">
        <div className="dashboard-content-v-user">
          <Header title="User's Dashboard" />
          <div className="inside-bg-user">
            <div className="dash-grids-user">
              <div className="revenue-sideline-user">
                <div className="stats-grid-user">
                  <div className="stat-card-1-user">
                    <div className="stat-header-user">
                      <img src={Revenue} />
                      <h3> Available Balance </h3>
                    </div>
                    <hr className="gradient-line-user" />
                    <div className="values-full-div-user">
                      <div className="stat-value-user">
                        ₹{" "}
                        {formatNumber(
                          Number(
                            proPartnerRelatedData?.revenueDetails?.revenue
                          )
                        ) || 0}{" "}
                      </div>
                      <div>
                        <span className="trend positive-user">
                          withdraw Amt : ₹{" "}
                          {formatNumber(
                            proPartnerRelatedData?.revenueDetails
                              ?.withdrawAmount
                          ) || 0}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="small-vertical-line-user"></div>
              </div>

              <div className="summary-content-user">
                <div className="pie-chart-container">
                  <ResponsiveContainer width="100%" height={250}>
                    <PieChart>
                      <Tooltip
                        contentStyle={{
                          backgroundColor: "#FFEAE2",
                          borderRadius: "8px",
                          border: "none",
                          color: "var(--white)",
                          fontSize: "14px",
                          padding: "8px",
                        }}
                        formatter={(value) => [`${value}`, ""]}
                      />
                      <Pie
                        data={paymentData}
                        dataKey="value"
                        nameKey="name"
                        cx="50%"
                        cy="50%"
                        innerRadius="60%"
                        outerRadius="80%"
                        strokeWidth={0}
                        paddingAngle={2}
                      >
                        {paymentData.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                      </Pie>
                    </PieChart>
                  </ResponsiveContainer>
                </div>
                <div className="payment-details-user">
                  <div className="payment-values_s">
                    {paymentData.map((item, index) => (
                      <div key={index} className="payment-item-user">
                        {Number(item?.value)?.toFixed(2)}
                      </div>
                    ))}
                  </div>
                  <div className="payment-values-user">
                    {paymentData.map((item, index) => (
                      <div key={index} className="payment-item-user">
                        <div
                          className="payment-ellipse-user"
                          style={{
                            width: "12px",
                            height: "12px",
                            backgroundColor: item.color,
                            borderRadius: "50%",
                            display: "inline-block",
                          }}
                        />
                        <div className="payment-label-user">{item?.name}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="tabs-container">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`tab-button ${
                    selectedTab === tab ? "active" : ""
                  }`}
                  onClick={() => setSelectedTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="payments-section">
              <div className="section-header-user">
                <div className="search-container">
                  <SearchIcon
                    style={{ color: "var(--thirdshade-orange)" }}
                    className="search-icon"
                  />
                  <input
                    type="text"
                    placeholder="Search here"
                    className="search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>

                <div className="table-actions">
                  <StatusFilter
                    onFilterChange={handleFilterChangePaymentsType}
                    activeFilter={activeFilter}
                    setActiveFilter={setActiveFilter}
                    type="PaymentofStatus"
                  />
                  <DateFilter
                    onFilterChange={handleDateFilterChange}
                    activeFilter={activeFilter}
                    setActiveFilter={setActiveFilter}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  backgroundColor: "#eff8fa",
                  padding: "1rem",
                  alignItems: "center",
                }}
              >
                <span>
                  {dateFilter?.filterType?.toUpperCase() === "CUSTOM"
                    ? `${dateFilter?.fromDate || ""}  to  ${
                        dateFilter?.toDate || ""
                      }`
                    : dateFilter?.filterType || ""}
                </span>
                <span>
                  {" "}
                  value : ₹{" "}
                  {Number(
                    proPartnerRelatedData?.revenueDetails?.overAllTotalValue ||
                      0
                  ).toFixed(2)}
                </span>
                <span className="earnings-total-amount">
                  {" "}
                  Earnings : ₹{" "}
                  {Number(
                    proPartnerRelatedData?.revenueDetails
                      ?.overAllTotalCommValue || 0
                  ).toFixed(2)}
                </span>
              </div>

              <div className="common-table-v">
                <table>
                  <thead>
                    <tr>
                      <th style={{ textAlign: "left" }}>User Id</th>
                      <th>Status</th>
                      <th>Activity</th>
                      <th>No. of Transactions</th>
                      <th>Total Value</th>
                      <th>Commission</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginateData(filteredRows).map((row, index) => {
                      let highestOne = 0;
                      let activity = "";
                      row.history?.forEach((each) => {
                        if (highestOne < each?.totalTransactionAmount) {
                          activity = each?.label;
                          highestOne = each?.totalTransactionAmount;
                        }
                      });

                      return (
                        <React.Fragment key={index}>
                          <tr
                            onClick={() => toggleRow(index)}
                            style={{
                              cursor: "pointer",
                              borderBottom: "1px solid #D0D0D0",
                            }}
                          >
                            <td>
                              <div className="user-table-td">
                                <p
                                  className="users-truncate-text"
                                  title={row?.userName}
                                >
                                  {row?.userName
                                    ? formatName(row?.userName).length > 25
                                      ? formatName(row?.userName).slice(0, 25) +
                                        "..."
                                      : formatName(row?.userName)
                                    : ""}
                                </p>
                                <p
                                  style={{
                                    textAlign: "left",
                                    margin: "0px",
                                    color: "var(--medium-black)",
                                  }}
                                >
                                  {row?.merchantId}{" "}
                                  <img
                                    src={CopyIcon}
                                    alt="Copy"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      copyToClipboard(row.merchantId);
                                    }}
                                  />
                                </p>
                              </div>
                            </td>

                            <td>
                              <span
                                className={`userstatus ${
                                  row?.status?.toLowerCase() === "active"
                                    ? "success"
                                    : "failed"
                                }`}
                              >
                                {row?.status?.toLowerCase() === "deactive"
                                  ? "Inactive"
                                  : row?.status}
                              </span>
                            </td>
                            <td>{activity || "N/A"}</td>
                            <td>{row?.noOfTransactions || 0}</td>
                            <td>₹ {row?.totalAmount?.toFixed(2) || 0}</td>
                            <td>₹ {row?.commissionAmount?.toFixed(2) || 0}</td>
                            <td>
                              <DownOutlined
                                onClick={() => toggleRow(index)}
                                style={{
                                  transform:
                                    expandedRow === index
                                      ? "rotate(180deg)"
                                      : "rotate(0deg)",
                                  transition: "transform 0.3s ease",
                                }}
                              />
                            </td>
                          </tr>

                          {expandedRow === index && (
                            <tr
                              className="expanded-row"
                              style={{ margin: "0px" }}
                            >
                              <td
                                style={{ backgroundColor: "none" }}
                                colSpan="3"
                              ></td>
                              <td colSpan="4" style={{ width: "100%" }}>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Category</th>
                                      <th>Transaction Count</th>
                                      <th>Transaction Amount</th>
                                      <th>Commission Amount</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {row?.history &&
                                      row?.history.length > 0 &&
                                      row?.history.map((sub, subInd) => {
                                        return (
                                          <tr key={subInd}>
                                            <td>
                                              <strong>{sub?.label}</strong>
                                            </td>
                                            <td>
                                              {sub?.totalTransactionCount || 0}
                                            </td>
                                            <td>
                                              ₹{" "}
                                              {sub?.totalTransactionAmount?.toFixed(
                                                2
                                              ) || 0}
                                            </td>
                                            <td>
                                              ₹{" "}
                                              {sub?.commission?.toFixed(2) || 0}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {filteredRows.length > 0 && (
                <div className="pagination-controls">
                  <div>
                    <Select
                      value={itemsPerPage}
                      onChange={(e) => {
                        setItemsPerPage(e.target.value);
                        setCurrentPage(1);
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }}
                      className="itemsperpage"
                    >
                      {recordsPerPageOptions.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>

                  <div
                    style={{ display: "flex", alignItems: "center", gap: 8 }}
                  >
                    <button
                      disabled={currentPage === 1}
                      onClick={() =>
                        handlePrevNext(Math.max(1, currentPage - 1))
                      }
                      style={{
                        background: "none",
                        border: "none",
                        cursor: currentPage === 1 ? "not-allowed" : "pointer",
                        opacity: currentPage === 1 ? 0.5 : 1,
                      }}
                    >
                      <NavigateBeforeIcon sx={{ fontSize: 18 }} />
                    </button>

                    {pageNumbers.map((page) => (
                      <button
                        key={page}
                        onClick={() => handlePageChange(page)}
                        style={{
                          padding: "6px 12px",
                          borderRadius: "8px",
                          border: "none",
                          backgroundColor:
                            currentPage === page
                              ? "rgba(0, 123, 255, 0.2)"
                              : "#ccc",
                          color: currentPage === page ? "#000" : "#fff",
                          fontWeight: currentPage === page ? "bold" : "normal",
                          cursor: "pointer",
                        }}
                      >
                        {page}
                      </button>
                    ))}

                    <button
                      disabled={currentPage === totalPages}
                      onClick={() =>
                        handlePrevNext(Math.min(totalPages, currentPage + 1))
                      }
                      style={{
                        background: "none",
                        border: "none",
                        cursor:
                          currentPage === totalPages
                            ? "not-allowed"
                            : "pointer",
                        opacity: currentPage === totalPages ? 0.5 : 1,
                      }}
                    >
                      <NavigateNextIcon sx={{ fontSize: 18 }} />
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProPartnerUsers;
